module.exports = __webpack_public_path__ + "DINNextLTPro-Regular.ttf?fd077957cfd14ef4e88d209d389412ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Regular.ttf
// module id = 1378
// module chunks = 0